(function(){
    angular.module('crud',[]);
})();

